const SPA_LINK = process.env.REACT_APP_REMITTANCE_LINK_FOR_SPA;
const SOPA_LINK = process.env.REACT_APP_REMITTANCE_LINK_FOR_SOPA;
const ISM_LINK = process.env.REACT_APP_REMITTANCE_LINK_FOR_ISM;
const REMITTANCE_REDIRECT = process.env.REACT_APP_REMITTANCE_REDIRECT;

const roleConfig = [
  {
    key: "SPA_Principal",
    ssoRole: "SPA Principal",
    link: SPA_LINK,
  },
  {
    key: "ISM_Partner_Principal",
    ssoRole: "ISM Partner Principal",
    link: SOPA_LINK,
  },
  {
    key: "ISM_Partner_Accountant",
    ssoRole: "ISM Partner Accountant",
    link: SOPA_LINK,
  },
  {
    key: "ISM_Accountant",
    ssoRole: "ISM Accountant",
    link: ISM_LINK,
  },
  {
    key: "ISM_Principal",
    ssoRole: "ISM Principal",
    link: ISM_LINK,
  },
];

const getRemittanceRedirectLink = (ssoRole) => {
    let remittanceLink = REMITTANCE_REDIRECT;
    roleConfig.map((config)=>{
        if(config.ssoRole === ssoRole) {
            remittanceLink = config.link
        }
    });
    return remittanceLink;
};

export default getRemittanceRedirectLink;